module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-82d35329.png";